import { h, FunctionalComponent } from 'preact';
import { Suspense, lazy } from 'preact/compat';

import { ICalendarProps } from './calendar.types';

import './calendar.css';

const CalendarWidget = lazy(() => import('./calendar'));

const Loader: FunctionalComponent<{ currentOrigin: string }> = ({ currentOrigin }) => {
  return (
    <div className="loader-wrapper">
      <img
        alt="alt info"
        className="loader"
        width={150}
        height={200}
        src={`${currentOrigin}/cascoon/schedule_loader.svg`}
      />
    </div>
  );
};

export const Calendar: FunctionalComponent<ICalendarProps> = (props: ICalendarProps) => {
  const { children, widget } = props;
  const renderLoader = () => <Loader currentOrigin={widget.currentOrigin} />;
  return (
    <div className="calendar-lazy-wrapper">
      <Suspense fallback={renderLoader()}>
        <CalendarWidget
          {...props} // eslint-disable-line react/jsx-props-no-spreading
        >
          {children}
        </CalendarWidget>
      </Suspense>
    </div>
  );
};
